module.exports = __webpack_public_path__ + "img/zhuanhua.61a8859e.svg";